export const isNullOrEmpty = (s: string | null | undefined): s is null | undefined => {
    return s === undefined || s === null || s.trim().length === 0;
};

export const trimValue = (value: string | null | undefined): null | undefined | string => {
    if (value === undefined) {
        return undefined;
    }
    return value === null || value.trim().length === 0 ? null : value?.trim();
};

type DiffValue = string | number | boolean | null | undefined | DiffRecord | DiffValue[];
type DiffRecord = { [key: string]: DiffValue };

const isDiffRecord = (value: DiffValue): value is DiffRecord =>
    typeof value === 'object' && value !== null && !Array.isArray(value);

export const diff = (previous: DiffRecord, next: DiffRecord): DiffRecord => {
    const result: DiffRecord = {};

    for (const key of new Set([...Object.keys(previous), ...Object.keys(next)])) {
        const previousValue = previous[key];
        const nextValue = next[key];

        if (isDiffRecord(previousValue) && isDiffRecord(nextValue)) {
            const nestedDifference = diff(previousValue, nextValue);
            if (Object.keys(nestedDifference).length > 0) {
                result[key] = nestedDifference;
            }
        } else if (!Object.is(previousValue, nextValue)) {
            result[key] = nextValue;
        }
    }

    return result;
};
